import BstlArtikel from "@/entities/common/bstl_artikel"
import BPArtikelAnzahlRequest from "@/entities/common/pending/bp_artikel_anzahl_request"
import BPArtikelHinzufuegenRequest from "@/entities/common/pending/bp_artikel_hinzufuegen_request"
import RemoteResult from "@/entities/common/remote_result"
import IdRequest from "@/entities/common/request/id_request"
import ReservierungNeu from "@/entities/common/reservierung_neu"
import ProdukteLogic from "@/logic/produkte_logic"
import router from "@/router"
import ConverterUtil from "@/util/converter_util"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import PreislisteZeitraumRequest from "@/entities/common/request/preisliste_zeitpunkt_request"
import PlisteProduktZeit from "@/entities/common/pliste_produkt_zeit"

export default class ReservierungVorbestellungLogic extends ProdukteLogic {
  bestellungCompleted: boolean = false
  reservierung: ReservierungNeu = null
  insertCompleted: boolean = false
  reservierungId: string = null
  private _warenkorb: BstlArtikel[] = []

  get warenkorb(): BstlArtikel[] {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  loadPreislisten() {
    var request = new PreislisteZeitraumRequest()
    request.zeitpunkt = this.reservierung.zeitVon

    request.filialeId = this.filiale.filialeId

    if (this.mainLogic.reservierung.vorbestellungPending) {
      this._warenkorb =
        this.mainLogic.reservierung.vorbestellungPending.artikelliste
    }

    this.loadError = false

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request
    ).then((response) => {
      if (response.data.success) {
        this.preisliste = response.data.payload
      } else {
        this.loadError = true
      }
    })
  }

  init() {
    this.reservierung = this.mainLogic.reservierung
    if (this.reservierung != null) this.loadPreislisten()

    this.mainLogic.reservierungListeners.push(() => {
      this.reservierung = this.mainLogic.reservierung
      if (this.reservierung != null) this.loadPreislisten()
    })
  }

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.RESERVIERUNG.VORBESTELLUNG_BESTAETIGEN,
    })
  }

  addArtikel(artikel: BstlArtikel): void {
    this.insertWorking = true

    var request = new BPArtikelHinzufuegenRequest()
    request.id = this.reservierungId
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)

    this.insertError = false

    Poster.postUser<RemoteResult<BstlArtikel>>(
      RestPaths.reservierungenVorbestellungPendingArtikelHinzufuegen,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.warenkorb.push(artikel)
          this.artikel = null
          this.artikelDialogVisible = false
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  geheZurBestellung() {
    router.push({
      name: RouteNames.RESERVIERUNG_DETAILS,
      params: { reservierungId: this.reservierungId },
    })
  }

  bestellungBestaetigen() {
    this.insertWorking = true
    this.insertError = false
    this.insertCompleted = false

    var request = new IdRequest()
    request.id = this.reservierungId

    Poster.postUser<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingBestaetigen,
      request
    )
      .then((response) => {
        this.insertWorking = false
        if (response.data.success) {
          this.bestellungCompleted = true
          this.insertCompleted = true
        } else {
          this.insertError = true
        }
      })
      .catch(() => {
        this.insertWorking = false
        this.insertError = true
      })
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.vorbestellungPending.id
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = this.mainLogic.reservierung.vorbestellungPending.id
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.reservierungenVorbestellungPendingArtikelAendern,
        request
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.vorbestellungPending.id
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }
}